import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
    mode: 'history',
    scrollBehavior: function(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    },
    routes: [{
            path: '/',
            name: '/',
            component: () =>
                import ('@/view'),
            redirect: { name: 'home' },
            children: [{
                    path: '/home',
                    name: 'home',
                    component: () =>
                        import ('@/view/home')
                },
                {
                    path: '/news',
                    name: 'news',
                    component: () =>
                        import ('@/view/news')
                },
                {
                    path: '/work',
                    name: 'work',
                    component: () =>
                        import ('@/view/work'),
                },
                {
                    path: '/plan',
                    name: 'plan',
                    component: () =>
                        import ('@/view/plan')
                },
                {
                    path: '/curriculum',
                    name: 'curriculum',
                    component: () =>
                        import ('@/view/curriculum')
                },
                // {
                //   path:'/curriculum/eyesDetail/:id',
                //   name:'eyesDetail',
                //   component:eyesDetail
                // },
                {
                    path: '/school',
                    name: 'school',
                    component: () =>
                        import ('@/view/school')
                },
                {
                    path: '/events',
                    name: 'events',
                    component: () =>
                        import ('@/view/events')
                },
                {
                    path: '/notice',
                    name: 'notice',
                    component: () =>
                        import ('@/view/notice')
                },
                {
                    path: '/dszt',
                    name: 'dszt',
                    component: () =>
                        import ('@/view/dszt')
                },
                {
                    path: '/bh',
                    name: 'bh',
                    component: () =>
                        import ('@/view/bh')
                },
                {
                    path: '/sqyr',
                    name: 'sqyr',
                    component: () =>
                        import ('@/view/sqyr')
                },
                {
                    path: '/routerLink',
                    name: 'routerLink',
                    component: () =>
                        import ('@/view/routerLink')
                }
            ]
        },
        {
            path: '/loading',
            name: 'loading',
            component: () =>
                import ('@/view/loading'),
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('@/view/login')
        }, {
            path: '/authLogin',
            name: 'authLogin',
            component: () =>
                import ('@/view/authLogin')
        },
        {
            name: 'play',
            //bcid课程id chapterid章ID sectionid节ID contentid内容ID flag为0能回复 为1能评论 为2不能删除评论回复 为3评论回复全部不显示 taskid任务ID playmulti是否允许多个
            path: '/play/:bcid/:chapterid/:sectionid/:contentid',
            component: () =>
                import ('@/view/play'),
            hidden: true
        },
        {
            path: '*',
            component: () =>
                import ('@/view/404'),
            hidden: true
        },
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js